import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import MsLogo from "../../../Images/msLogo.svg";
import MsNavButtons from "./MsNavButtons";
// import { FaBars, FaTimes } from "react-icons/fa";
import styled from "styled-components";

const MsHeader = () => {
  const logoSrc = MsLogo;
  // const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/mini-store">
          <LogoImg src={logoSrc} alt="Mini Store Logo" />
        </Link>

        {/* Hamburger Icon */}
        {/* <button
          className="navbar-toggler"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button> */}

        {/* Navigation Menu */}
        {/* <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
          <ul
            className={`navbar-nav ${
              menuOpen ? "ms-auto" : "justify-content-end w-100"
            }`}
          >
            <MsNavButtons />
            </ul>
          </div> */}
        <MsNavButtons />
      </div>
    </nav>
  );
};

export default MsHeader;
const LogoImg = styled.img`
  max-width: 120px;
  max-height: 50px;
  object-fit: contain;
  width: auto;
  height: auto;
  display: block;
  @media (max-width: 520px) {
    max-width: 80px;
    max-height: 50px;
  }
`;
